const topics = [
  { name: '狂飙全集', count: '12.8万讨论', hot: true },
  { name: '繁花大结局', count: '10.5万讨论', hot: true },
  { name: '国产悬疑剧推荐', count: '9.2万讨论', hot: false },
  { name: '韩剧完整版', count: '8.7万讨论', hot: true },
  { name: '电视剧在线全集', count: '7.3万讨论', hot: false },
  { name: '琅琊榜重温', count: '6.8万讨论', hot: false },
  { name: '黑暗荣耀第二季', count: '6.1万讨论', hot: true },
  { name: '美剧高清全集', count: '5.5万讨论', hot: false },
  { name: '高分日剧全集', count: '4.9万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              热门话题
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              追剧社区正在热烈讨论的电视剧全集话题，看看大家都在聊什么
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`group flex items-center gap-2.5 px-5 py-3 rounded-full cursor-pointer transition-all duration-200 border ${
                  topic.hot
                    ? 'bg-primary-500/10 border-primary-500/25 hover:bg-primary-500/20'
                    : 'bg-background-100 border-background-300/30 hover:border-primary-500/30'
                }`}
              >
                {topic.hot && (
                  <i className="ri-fire-line text-primary-400 text-sm"></i>
                )}
                <span className={`text-sm font-medium whitespace-nowrap ${
                  topic.hot ? 'text-foreground-100' : 'text-foreground-300'
                }`}>
                  #{topic.name}
                </span>
                <span className="text-foreground-500 text-xs whitespace-nowrap">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}